import { render, staticRenderFns } from "./ConfirmationRegisterModal.vue?vue&type=template&id=1bed7702&scoped=true&"
import script from "./ConfirmationRegisterModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationRegisterModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationRegisterModal.vue?vue&type=style&index=0&id=1bed7702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed7702",
  null
  
)

export default component.exports